module.exports = __webpack_public_path__ + "img/block01_h5.0ecd163f.webp";